import { State, createFeatureSelector, createSelector, createSelectorFactory, defaultMemoize } from "@ngrx/store";
import * as mainReducers from '@app/store/features/main/main.reducers';
import * as TablesReducer from './games.reducer';
import { VariantType2 } from "@app/enums/variant-type-2";

export const selectMainState = createFeatureSelector<mainReducers.MainState>('main');
export const selectGamesState = createSelector(selectMainState, (state) => state.games);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal,
} = TablesReducer.adapter.getSelectors(selectGamesState);

export const selectEntityById = (id: number) => createSelector(
    selectEntities,
    (entities) => entities[id]
);

const selectTournamentIndex = createSelector(
    selectGamesState,
    s => s.tournamentIndex
);

export const selectEntityByTournamentId = (idTournament: number) =>
    createSelector(selectTournamentIndex, selectEntities, (idx, entities) => {
        const idTable = idx[idTournament];
        return idTable != null ? entities[idTable] ?? null : null;
    });

export const selectGameActionByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.action
);

export const selectPreviousHandNumberByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.previousHandNumber
);


export const selectGameHistoryEventsByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.gameHistoryEvents
);

export const selectOptionEnableR2TByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.optionEnableR2T
);

export const selectOptionForcedR2TByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.optionForcedR2T
);


export const selectGameBetControlsByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.gameBetControls
);

export const selectGameHandNumberByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.handNumber
);

export const selectGameCurrentHandNumberByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.currentHandNumber
);

export const selectGameReplayActionByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.gameReplayAction
);


export const selectGamePreBetControlssByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.gamePreBetControls
);

export const selectGameActionControlssByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.gameActionControls
);

export const selectGameChatByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.chat
);


export const selectGameCurrencyByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.currency
);

export const selectGamePlayersStatisticsByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.playersStatistics ?? {}
);

export const selectGameActive = () => createSelector(
    selectGamesState,
    (state) => state?.activeTableId
);

export const selectGameOpened = () => createSelector(
    selectGamesState,
    (state) => state?.openedTables
);

export const selectGameHandReplaySpeedTime = () => createSelector(
    selectGamesState,
    (state) => state?.replaySpeedTime
);




// 🐇 Rabbit Hunting

export const selectFreeRabbitHunting = () => createSelector(
    selectGamesState,
    (state) => state?.freeRabbitHunting
);


export const selectGameFreeRabbitHuntingByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.freeRabbitHunting
);



export const selectGameCommunityCardsByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.communityCards
);

export const selectGameChargedRabbitHuntingByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.chargedRabbitHunting
);

export const selectGameRabbitHuntingPriceByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.rabbitHuntingPrice
);


// Draw Games

export const selectDrawGameByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.drawGame
);



// Hand Type

export const selectGameVariantByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.variant
);

export const selectGameIsMixTableByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.isMixTable
);

export const selectGameHandTypeByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.handType
);

export const selectGameSecondBoardHandTypeByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.secondBoardHandType
);

export const selectGameSecondBoardHiLoWinByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.secondBoardHiLoWin
);


export const selectGamePlayStatisticsByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.playStatistics
);

export const selectGameJackPotPrizeByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.jackPotPrize
);

export const selectHandHistory = () => createSelector(
    selectGamesState,
    (state) => state?.handHistory
);

export const selectTableSessions = () => createSelector(
    selectGamesState,
    (state) => state?.tableSessions
);

export const selectHandSessions = () => createSelector(
    selectGamesState,
    (state) => state?.handSessions
);

// Table Info
export const selectGameTableNameByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.tableName
);

export const selectGameBringInByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.optionBringIn ? entities[idTable]?.bringIn : null

);

export const selectGameAnteByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.ante
);

export const selectGameBlindByTableId = (idTable: number) => createSelector(
    selectEntities,
    (entities) => entities[idTable]?.blind
);

// ✅ Custom memoized selector for opened games (recalculates only if needed)
export const selectOpenedGames = createSelectorFactory(
    projector => defaultMemoize(projector, areEqualOpenedGames)
)(
    selectAll,
    selectGameOpened(),
    (games: TablesReducer.Game[], openedTables: number[]): TablesReducer.Game[] => {
        const openedSet = new Set(openedTables);
        return games.filter(game => openedSet.has(game.idTable));
    }
);

// ✅ Custom equality function (only compares onMove and cardsInHand)
function areEqualOpenedGames(prev: TablesReducer.Game[], curr: TablesReducer.Game[]): boolean {

    if (prev.length !== curr.length) {

        return false;
    }

    const prevMap = new Map(prev.map(game => [game.idTable, game]));

    for (const currGame of curr) {
        const prevGame = prevMap.get(currGame.idTable);
        if (!prevGame) {

            return false;
        }

        if (
            prevGame.onMove !== currGame.onMove ||
            prevGame.cardsInHand !== currGame.cardsInHand ||
            prevGame.miniTableTimer !== currGame.miniTableTimer ||
            prevGame.folded !== currGame.folded ||
            prevGame.isReplay !== currGame.isReplay ||
            prevGame.tableName !== currGame.tableName
        ) {
            return false;
        }
    }
    return true;
}